import React from 'react'
import { AcademicCapIcon, CurrencyDollarIcon, XMarkIcon } from '@heroicons/react/24/outline'
import clsx from 'clsx'

interface FeatureNoticeProps {
  type: 'subscription' | 'credits'
  message?: string
  onDismiss?: () => void
  className?: string
}

export const FeatureNotice: React.FC<FeatureNoticeProps> = ({
  type,
  message,
  onDismiss,
  className,
}) => {
  const isSubscription = type === 'subscription'
  const defaultMessage = isSubscription
    ? 'This feature is available for subscribed users.'
    : 'Insufficient credits to use this feature.'

  return (
    <div
      className={clsx(
        'flex items-center justify-between p-4 rounded-lg border',
        isSubscription
          ? 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800'
          : 'bg-orange-50 dark:bg-orange-900/20 border-orange-200 dark:border-orange-800',
        className
      )}
    >
      <div className="flex items-center gap-3 flex-1">
        {isSubscription ? (
          <AcademicCapIcon className="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0" />
        ) : (
          <CurrencyDollarIcon className="w-5 h-5 text-orange-600 dark:text-orange-400 flex-shrink-0" />
        )}
        <p
          className={clsx(
            'text-sm font-medium',
            isSubscription
              ? 'text-blue-900 dark:text-blue-200'
              : 'text-orange-900 dark:text-orange-200'
          )}
        >
          {message || defaultMessage}
        </p>
      </div>
      <div className="flex items-center gap-2 ml-4">
        {onDismiss && (
          <button
            onClick={onDismiss}
            className={clsx(
              'p-1.5 rounded-md hover:bg-opacity-20 transition-colors',
              isSubscription
                ? 'text-blue-600 dark:text-blue-400 hover:bg-blue-200 dark:hover:bg-blue-800'
                : 'text-orange-600 dark:text-orange-400 hover:bg-orange-200 dark:hover:bg-orange-800'
            )}
          >
            <XMarkIcon className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  )
}

